<template>
	<modal size="small-medium" @close="close">
		<template slot="header">
			<h3>{{ $t('User Details') }}</h3>
		</template>
		<template slot="body">
			<div class="row">
				<div class="col-sm-6">
					<!-- Name -->
					<div class="form-group">
						<div class="text-bold">{{ $t('Name') }}:</div>
						<div class="">{{ user.name }}</div>
					</div>
				</div>
				<div class="col-sm-6">
					<!-- Phone -->
					<div class="form-group">
						<div class="text-bold">{{ $t('Phone') }}:</div>
						<div class="">{{ user.phone }}</div>
					</div>
				</div>
				<div class="col-sm-12">
					<!-- Email -->
					<div class="form-group">
						<div class="text-bold">{{ $t('Email') }}:</div>
						<div class="">{{ user.email }}</div>
					</div>
				</div>
				<div class="col-sm-6 hidden">
					<!-- ID Card -->
					<div class="form-group">
						<div class="text-bold">{{ $t('ID Card') }}:</div>
						<img
							:src="idCardLink"
							alt="ID Card"
							v-if="idCardLink"
						>
					</div>
				</div>
			</div>

			<hr>

			<!-- Features -->
			<user-features :user="user" />
		</template>
		<div slot="footer">
			<button
				type="button"
				class="btn btn-primary"
				@click="close">
				{{ $t('OK') }}
			</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import UserFeatures from '@/components/UserFeatures.vue';

export default {
	name: 'UserDetails',
	components: {
		Modal,
		UserFeatures,
	},
	props: {
		user: {
			type: Object,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		idCardLink() {
			// eslint-disable-next-line camelcase
			const path = this?.user?.settings?.id_card ?? false;
			const link = `https://cdn.ostock.id${path}`;
			return link;
		},
	},
	created() {
	},
};
</script>
